import { z } from "zod";
import { momentSchema } from "./zod-utils";
import { TicketCategoryCustomFieldSchema } from "./custom-field";

export const TICKET_SERVICE_PROVIDER_TYPES = ["internal", "external"] as const;
export const TicketServiceProviderTypeSchema = z.enum(TICKET_SERVICE_PROVIDER_TYPES);
export type TicketServiceProviderType = z.infer<typeof TicketServiceProviderTypeSchema>;
export const TICKET_SERVICE_PROVIDER_TYPE = TicketServiceProviderTypeSchema.enum;

export const TicketInternalServiceProviderSchema = z.object({
  type: z.literal(TICKET_SERVICE_PROVIDER_TYPE.internal),
  userUuid: z.uuid(),
});

export const TicketExternalServiceProviderSchema = z.object({
  type: z.literal(TICKET_SERVICE_PROVIDER_TYPE.external),
  email: z.email(),
});

export const TicketServiceProviderSchema = z.discriminatedUnion("type", [
  TicketInternalServiceProviderSchema,
  TicketExternalServiceProviderSchema,
]);

export type TicketInternalServiceProvider = z.infer<typeof TicketInternalServiceProviderSchema>;
export type TicketExternalServiceProvider = z.infer<typeof TicketExternalServiceProviderSchema>;
export type TicketServiceProvider = z.infer<typeof TicketServiceProviderSchema>;

export const TicketCategoryBaseShape = {
  uuid: z.uuid(),
  name: z.string(),
  description: z.string(),
  companyUuid: z.uuid(),
  officeUuid: z.uuid(),
  serviceProviders: z.array(TicketServiceProviderSchema),
  isActive: z.boolean(),
  sortIndex: z.string(),
  createdByUserUuid: z.uuid(),
  customFields: z.array(TicketCategoryCustomFieldSchema),
};

export const TicketCategorySchema = z.object({
  ...TicketCategoryBaseShape,
  createdAt: momentSchema,
  updatedAt: momentSchema,
  deletedAt: momentSchema.nullable(),
});

export type TicketCategory = z.infer<typeof TicketCategorySchema>;
